var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Media Icon Square/YouTube"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Social Media Icon",
    x: 0.419891,
    width: 34.92,
    height: 34.9199,
    rx: 7.75999,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "YouTube",
    d: "M18.305 24.2307L14.3647 24.1571C13.0889 24.1314 11.8099 24.1826 10.5591 23.9168C8.65641 23.5196 8.52162 21.5719 8.38057 19.9382C8.18622 17.6414 8.26145 15.3029 8.62822 13.0253C8.83527 11.7473 9.6501 10.9847 10.9102 10.9017C15.164 10.6005 19.4461 10.6362 23.6904 10.7767C24.1387 10.7896 24.59 10.86 25.032 10.9401C27.2138 11.331 27.2671 13.5381 27.4085 15.3961C27.5495 17.2733 27.49 19.1601 27.2204 21.0244C27.0041 22.5681 26.5903 23.8626 24.8439 23.9876C22.6558 24.151 20.518 24.2825 18.3237 24.2406C18.3238 24.2307 18.3112 24.2307 18.305 24.2307ZM15.9884 20.3226C17.6373 19.3551 19.2548 18.4038 20.8943 17.4428C19.2423 16.4753 17.6279 15.5239 15.9884 14.5629V20.3226Z",
    fill: "#141619"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.73260f420a44c48c0d9d724dbc459ed0.svg";
export { ForwardRef as ReactComponent };